<script>
	// @ts-nocheck

	import { enhance } from '$app/forms';
	import { invalidateAll } from '$app/navigation';
	import { applyAction, deserialize } from '$app/forms';
	import { signIn } from '@auth/sveltekit/client';
	import { PUBLIC_SITE_URL } from '$env/static/public';
	// import mixpanel from 'mixpanel-browser';
	import { MetaTags } from 'svelte-meta-tags';
	import LoadingModal from '$lib/components/LoadingModal.svelte';
	import { getVersion } from '$lib/utils/version.js';
	import { navigating } from '$app/stores';
	import { page } from '$app/stores';

	export let form;

	export let data;

	let formError = {
		errorType: ''
	};

	$: {
		// login if success checking in server side
		if (form?.success) {
			loginHandle();
		}
	}

	async function loginHandle() {
		await signIn('credentials', {
			email: form?.email,
			password: form?.password,
			callbackUrl: inviteId ? `/dashboard?inviteId=${inviteId}` : '/dashboard',
			redirect: true
		});
	}

	let inviteId = $page.data.inviteId;
	let googleCallBackUrl = inviteId
		? `${PUBLIC_SITE_URL}/dashboard?inviteId=${inviteId}`
		: `${PUBLIC_SITE_URL}/dashboard`;

	let loginStatus;
	let loadingMod = false;

	if (data?.user?.email === 'failGoogle') {
		loginStatus = 'google-authentication';
		// mixpanel.identify(form?.email);
		// mixpanel.people.set({
		// 	email: form?.email
		// });
		// mixpanel.track("User's Login", {
		// 	email: form?.email
		// });
	}

	async function login() {
		loadingMod = true;
		const loginData = new FormData(this);

		// mixpanel.track("User's Login", {
		// 	'User ID': form?.email
		// });
		const res = await fetch(this.action, {
			method: 'POST',
			body: loginData
		});

		const result = deserialize(await res.text());

		if (result.type == 'success') {
			await invalidateAll();
			// mixpanel.identify(form?.email);
			// if (!mixpanel.get_property('First Login')) {
			// 	// Set the user property to "true" to indicate the first login
			// 	mixpanel.people.set_once({ 'First Login': true });
			// 	// Track the "First Login" event
			// 	mixpanel.track('First Login');
			// }

			// mixpanel.people.set({
			// 	email: form?.email
			// });
			// mixpanel.track('Session Start', {
			// 	'User ID': form?.email
			// });
			// Crisp.user.setEmail(form?.email);
			// @ts-ignore
			// Crisp.user.setNickname(user.firstname + user.lastname);

			// Crisp.session.setData({
			// 	email: form?.email,
			// 	// @ts-ignore
			// 	name: user.firstname + user.lastname
			// });
		}

		applyAction(result);

		if (!result.data.success) {
			loadingMod = false;
			formError.errorType = result.data.error;
		}
	}

	let show_password = false; //* Show/hide password
	const showPassHandler = () => {
		show_password = !show_password;
	};

	//* styling variables
	let welcomeText = 'text-main-color font-semibold text-4xl';
	let socialButtons =
		'btn gap-2 bg-white w-full border-solid border-2 border-social-btn-border text-text-color normal-case text-base font-normal mb-3 hover:bg-white hover:border-social-btn-border';
</script>

{#if !!$navigating}
	<LoadingModal showModal={true} />
{/if}

<MetaTags
	title="Dazle"
	titleTemplate="%s | log in or sign up"
	description="Add, manage, and instantly share property listings while on the go. And help match your client’s needs with ease using Dazle."
	canonical="https://app.dazle.co/login"
	openGraph={{
		url: 'https://app.dazle.co/login',
		title: 'Dazle log in or sign up',
		description:
			'Add, manage, and instantly share property listings while on the go. And help match your client’s needs with ease using Dazle.',
		images: [
			{
				url: 'https://brooky-attachments.s3.ap-southeast-1.amazonaws.com/1688516906361_For_tumbnail.png',
				width: 200,
				height: 100,
				alt: 'Dazle thumbnail'
			}
		],
		site_name: 'Dazle'
	}}
/>

<LoadingModal showModal={loadingMod} />
<div class="main-container lg:flex min-h-full">
	<div id="main-content-wrapper" class="w-full px-[24px] lg:w-7/12">
		<div id="title-and-social-wrapper" class=" max-w-[400px] mx-auto">
			<img
				src="/images/new-dazle-logo.svg"
				alt="dazle-logo"
				class="w-[108px] h-[42px] mx-auto mt-[55px] lg:mx-0"
			/>

			<h1 class="{welcomeText} mt-[26px]">Hello.</h1>

			<h1 class="{welcomeText} mb-[44px]">Welcome Back</h1>

			<div id="social-btns-wrapper" class="">
				<!-- * Facebook  -->
				<!-- <button class={socialButtons} on:click={() => signIn("facebook", {callbackUrl: PUBLIC_SITE_URL+'/dashboard'})}>
                    <img src="/images/facebook-icon.svg" alt="fb-icon">
                    Log in with Facebook
                </button> -->
				<!-- * Google  -->
				<button
					class={socialButtons}
					on:click={() => signIn('google', { callbackUrl: googleCallBackUrl })}
				>
					<!-- signIn('google', { callbackUrl: PUBLIC_SITE_URL + '/dashboard?test=123' })} -->
					<img src="/images/google-icon.svg" class="w-[26px] h-[25px]" alt="google-icon" />
					Log in with Google
				</button>
			</div>
		</div>

		<!-- Divider -->
		<div class="divider text-grey-hint-two text-sm max-w-[400px] mx-auto">
			or Log in using your Email address
		</div>

		<div id="login-form-wrapper" class="max-w-[400px] mx-auto">
			<div id="form-wrapper" class="">
				<!-- * Login Message Fail -->
				{#if formError.errorType}
					<div class="alert alert-error shadow-xl mb-3">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="stroke-current shrink-0 h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							><path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
							/></svg
						>
						<span>
							{#if formError.errorType === 'not_found'}
								The email or password is incorrect.
							{:else}
								This account was registered using Google Quick Sign-up.
							{/if}
						</span>
					</div>
				{/if}

				{#if loginStatus === 'google-authentication'}
					<div class="alert alert-error shadow-lg">
						<div>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="stroke-current flex-shrink-0 h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								><path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
								/></svg
							>

							<span>This account was registered with Email and Password.</span>
						</div>
					</div>
				{/if}

				<form use:enhance method="POST" on:submit|preventDefault={login} action="/login?/login">
					<div class="w-full">
						<label class="flex flex-col">
							<span class="flex justify-start pl-3 pb-2">Email</span>

							<input
								required
								type="email"
								placeholder="Enter Email"
								name="email"
								id="email"
								class="input input-bordered w-full"
								value={form?.email ?? ''}
							/>
						</label>
					</div>
					<div class="w-full">
						<label class="flex flex-col">
							<span class="flex justify-start pl-3 py-2">Password</span>

							<div class="relative">
								<input
									required
									type={show_password ? 'text' : 'password'}
									placeholder="Enter Password"
									name="password"
									id="password"
									class="input input-bordered w-full"
								/>
								<div
									class="absolute top-4 right-4 cursor-pointer"
									on:click={showPassHandler}
									aria-hidden="true"
								>
									{#if show_password}
										<img src="images/hide-icon.svg" alt="show-pass-icon" class="w-[20px]" />
									{:else}
										<img
											src="images/unhide-icon.svg"
											alt="show-pass-icon"
											class="w-[20px] h-[21px]"
										/>
									{/if}
								</div>
							</div>
						</label>
						<!-- <a href="" class="">Forgot password</a> -->
					</div>
					<button
						type="submit"
						class="btn bg-main-color w-full mt-5 border-none hover:bg-main-color"
					>
						<p class="text-white normal-case">Log in</p>
					</button>
				</form>
			</div>
		</div>
		<span class="text-sm text-center"
			><p class="display-inline mt-9">
				<a href="/login/forgot-password" class="sign-up-link">Forgot password?</a>
			</p></span
		>
		<span class="text-sm text-center"
			><p class="display-inline mt-4">
				Don't have an account? <a href="/signup" class="sign-up-link">Sign up</a>
			</p></span
		>

		<span class="text-sm text-center"
			><p class="display-inline mt-9 text-gray-500">
				v{getVersion()}
			</p></span
		>
	</div>

	<!-- Hero Section -->
	<div
		id="hero-wrapper"
		class="hidden lg:block bg-login-bg-img lg:w-5/12 min-h-fit bg-no-repeat bg-cover bg-center pl-[47px]"
	>
		<img src="/images/new-logo.svg" alt="dazle-logo" class="mt-16 max-h-8" />

		<h1 id="hero-text" class="text-3xl text-white font-semibold mb-7 mt-5 leading-normal">
			Tools you need to grow your Real Estate business
		</h1>

		<p class="text-white mb-12 text-lg">
			<span style="display: block; margin-bottom: 10px;">• Upload and Manage your listings</span>
			<span style="display: block; margin-bottom: 10px;">• Sellers Website</span>
			<span style="display: block; margin-bottom: 10px;">• Contact forms to get leads</span>
			<span style="display: block; margin-bottom: 10px;"
				>• Get leads and referrals for your buyers needs</span
			>
		</p>

		<img
			src="/images/dazle-login.svg"
			alt="mockup"
			class="min-h-[400px] max-h-[480px] w-full ml-0 object-cover object-left-top"
		/>
	</div>
</div>

<style>
	button:hover {
		box-shadow: inset 0em 0em 0em 10em rgba(0, 0, 0, 0.3);
	}

	.sign-up-link {
		color: #1f4bc6;
	}
</style>
